import Glide from "@glidejs/glide";

document.addEventListener("DOMContentLoaded", function () {
    const glide = new Glide('.glide', {
        type: 'carousel',
        startAt: 0,
        focusAt: 'center',
        autoplay: 5000,
        animationDuration: 500,
        perView: 3,
        gap: -50,
        breakpoints: {
            640: {
                perView: 1,
                gap: 20
            }
        }
    });

    // wait half a second before setting the active slide
    setTimeout(() => {
        document.querySelector('.glide__slide--active')?.classList.add('active');
        document.querySelector('.glide-controls .nav-bullet[data-index="0"]')?.classList.add('active');
    }, 500);

    glide.on('run.before', function (props) {
        // Remove active class from all slides
        document.querySelectorAll('.glide__slide').forEach(slide => {
            slide.classList.remove('active');
        });
        // remove active class from all bullets
        document.querySelectorAll('.glide-controls .nav-bullet').forEach(bullet => {
            bullet.classList.remove('active');
        });

        let nextSlideIndex = props.direction === '=' 
            ? props.steps 
            : props.direction === '>' 
            ? glide.index + 1 
            : glide.index - 1;

        // determine how many slides are in the carousel by counting the number of .glide__slide elements excluding the clones
        const slideCount = document.querySelectorAll('.glide__slide:not(.glide__slide--clone)').length;

        if (nextSlideIndex < 0) {
            nextSlideIndex = slideCount - 1;
        }
        else if (nextSlideIndex >= slideCount) {
            nextSlideIndex = 0;
        }

        // Add active class to the next slide using the data-index attribute
        document.querySelectorAll(`.glide__slide[data-index="${nextSlideIndex}"]`).forEach(slide => {
            slide.classList.add('active');
        });
        // add active class to the bullet at the next index
        document.querySelectorAll(`.glide-controls .nav-bullet[data-index="${nextSlideIndex}"]`).forEach(bullet => {
            bullet.classList.add('active');
        });
    });

    glide.mount();

    document.querySelector('.glide-controls .nav-arrow.prev').addEventListener('click', function () {
        glide.go('<');
    });

    document.querySelector('.glide-controls .nav-arrow.next').addEventListener('click', function () {
        glide.go('>');
    });

    document.querySelectorAll('.glide-controls .nav-bullet').forEach(function (bullet) {
        bullet.addEventListener('click', function () {
            const index = this.getAttribute('data-index');
            glide.go('=' + index);
        });
    });
});